import { render, staticRenderFns } from "./material-currency-info.vue?vue&type=template&id=031b577f&scoped=true&"
import script from "./material-currency-info.vue?vue&type=script&lang=js&"
export * from "./material-currency-info.vue?vue&type=script&lang=js&"
import style0 from "./material-currency-info.vue?vue&type=style&index=0&id=031b577f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b577f",
  null
  
)

export default component.exports